<template>
  <aside class="palette" aria-label="اجزای فرم">
    <div class="pal-group">
      <h3>پرسش‌ها</h3>
      <p>بکشید و در یک بخش رها کنید، یا کلیک کنید تا به بخش انتخاب‌شده اضافه شود.</p>
      <draggable :list="kinds" :group="{ name: 'questions', pull: 'clone', put: false }" :sort="false" :clone="cloneQuestion" tag="ul" class="pal-list">
        <li v-for="kind in kinds" :key="kind.name">
          <button type="button" class="pal-tile" :title="kind.hint" @click="$emit('add-question', kind.name)">
            <span class="pal-icon"><VnIcon :name="kind.icon" /></span>
            <span class="pal-copy"><b>{{ kind.label }}</b><small>{{ kind.hint }}</small></span>
          </button>
        </li>
      </draggable>
    </div>
    <div class="pal-group">
      <h3>ساختار</h3>
      <draggable :list="sectionTiles" :group="{ name: 'sections', pull: 'clone', put: false }" :sort="false" :clone="cloneSection" tag="ul" class="pal-list">
        <li v-for="tile in sectionTiles" :key="tile.name">
          <button type="button" class="pal-tile structure" @click="$emit('add-section')">
            <span class="pal-icon"><VnIcon name="section" /></span>
            <span class="pal-copy"><b>بخش تازه</b><small>گروهی از پرسش‌ها؛ یک مرحله در اپ</small></span>
          </button>
        </li>
      </draggable>
      <draggable :list="photoTiles" :group="{ name: 'photos', pull: 'clone', put: false }" :sort="false" :clone="clonePhoto" tag="ul" class="pal-list">
        <li v-for="tile in photoTiles" :key="tile.name">
          <button type="button" class="pal-tile structure" @click="$emit('add-photo')">
            <span class="pal-icon"><VnIcon name="camera" /></span>
            <span class="pal-copy"><b>مرحله‌ی تصویر</b><small>عکس با حداقل و حداکثر؛ قابل اتصال به پرسش</small></span>
          </button>
        </li>
      </draggable>
    </div>
  </aside>
</template>

<script>
import draggable from 'vuedraggable';
import VnIcon from '@/components/VnIcon/index.vue';
import { KINDS, KIND_ORDER, newQuestion, newSection, newPhoto } from '../designerModel';

export default {
  name: 'Palette',
  components: { draggable, VnIcon },
  props: { types: { type: Array, required: true } },
  data: () => ({ sectionTiles: [{ name: 'section' }], photoTiles: [{ name: 'photo' }] }),
  computed: {
    // only kinds the backend actually has
    kinds() { return KIND_ORDER.filter(name => this.types.some(type => type.name === name)).map(name => ({ name, ...KINDS[name] })); },
  },
  methods: {
    cloneQuestion(kind) { return newQuestion(kind.name, this.types); },
    cloneSection() { return newSection(''); },
    clonePhoto() { return newPhoto(''); },
  },
};
</script>

<style scoped>
.palette { display: grid; align-content: start; gap: 18px; }
.pal-group h3 { margin: 0 0 2px; font-size: 12px; font-weight: 900; color: var(--text-3); letter-spacing: .02em; }
.pal-group > p { margin: 0 0 8px; font-size: 11px; color: var(--text-4); line-height: 1.7; }
.pal-list { list-style: none; margin: 0; padding: 0; display: grid; gap: 6px; }
.pal-tile { display: flex; align-items: center; gap: 10px; width: 100%; padding: 8px 10px; border: 1px solid var(--line); border-radius: var(--r-sm);
  background: var(--surface); text-align: right; font: inherit; color: var(--text); cursor: grab; transition: border-color .15s, box-shadow .15s, transform .15s; }
.pal-tile:hover { border-color: var(--navy-900); box-shadow: 3px 3px 0 var(--navy-900); transform: translate(-1px, -1px); }
.pal-tile:active { cursor: grabbing; }
.pal-tile:focus-visible { outline: 3px solid var(--focus); outline-offset: 1px; }
.pal-icon { flex: none; width: 32px; height: 32px; display: grid; place-items: center; border-radius: var(--r-xs); background: var(--navy-50); color: var(--navy-900); font-size: 15px; --icon-accent: var(--teal-500); }
.structure .pal-icon { background: var(--navy-900); color: #fff; --icon-accent: var(--amber-500); }
.pal-copy { display: grid; min-width: 0; }
.pal-copy b { font-size: 12.5px; font-weight: 800; }
.pal-copy small { font-size: 10.5px; color: var(--text-3); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
</style>
